<template>
  <div class="side-menu-wrapper">
    <div class="menu-collapsed" style="border-right:1px solid #eee;"  ref="menu" >
      <template v-for="(item, index) in menuList">
        <Tooltip transfer :content="showTitle(item.children && item.children[0] ? item.children[0] : item)" placement="right" :key="`drop-menu-${item.name}`">
          <a class="drop-menu-a"
          :class="{'active' : getNameOrActive(item, true) == checkname }" 
          :key="index" 
          @click="handleSelect(getNameOrHref(item, true), item)"
          :style="{textAlign: 'center'}" >          
            <Icon :size="rootIconSize" :color="textColor" :type="item.icon || (item.children && item.children[0].icon)"></Icon>
            <span class="menu-title" >{{ showTitle(item) }}</span>
          </a>
        </Tooltip>
      </template>
    </div>
    <div v-show="!collapsed" class="submenu-collapsed">
      <template v-if="submenudata.children.length > 1">
        <template v-for="(items, index) in submenudata.children"   >
          <template v-if="typeof items.children !== 'undefined' && items.children.length > 0 ">
            <div class="submenu-collapsed-title" :key="index">
              <Icon :type="items.meta.icon" :size="16" />
              <strong>{{items.meta.title}}</strong>
            </div>
            <div class="submenu-collapsed-list"   :key="'items'+index">
              <ul>
                <template v-for="(items, index) in items.children">
                  <li :class="{'active' : items.name == checkSubname }" @click="handleSelectSub(items.name)"  :key="index">{{items.meta.title}}</li>
                </template>
              </ul>
            </div>
          </template>
          <template v-else>
            <div class="submenu-collapsed-last" :key="index" :class="{'active' : items.name == checkSubname }" @click="handleSelectSub(items.name)">
              <Icon :type="items.meta.icon" :size="16" />
              <span>{{items.meta.title}}</span>
            </div>
          </template>
        </template>
      </template>
      <template v-else>
        <div class="submenu-collapsed-title">
          <Icon :type="submenudata.meta.icon" :size="16" />
          <span>{{submenudata.meta.title}}</span>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { getSubMenu } from '@/library/utils'
import mixin from './mixin'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import { forEach, hasOneOf, objEqual } from '@/library/tools'

export default {
  name: 'SideMenu',
  mixins: [ mixin ],
  props: {
    collapsed: {
      type: Boolean
    },
    menuList: {
      type: Array,
      default () {
        return []
      }
    },
    rootIconSize: {
      type: Number,
      default: 20
    },
    iconSize: {
      type: Number,
      default: 16
    },
  },
  data () {
    return {
      openedNames: [],
      submenu: [],
      collapseditem: [
        'main_index',
        'trendsinfo',
        'prosurvey',
        'prohome'
      ]
    }
  },
  methods: {
    ...mapMutations([
      'setSubMenu',
      'setCollapsed',
    ]),
    handleSelect (name, item) {
        
      this.setSubMenu(item)
      this.$emit('on-select', name)
      if(name !== 'main_index' && name !== 'work' && name !=='iteration-list' && name !== 'work-order' && name !== 'project-list' && name !== 'work-list' && name !== 'trendsinfo' && name !== 'prosurvey' && name !== 'task-home' && name !== 'testhome' && name !== 'library' && name !== 'testplan' && name !== 'docs'  && name !== 'docs-edit' && name !== 'reports' && name !== 'gitRepoList'){
        this.setCollapsed(false)
      }else{
        this.setCollapsed(true)
      }
    },
    handleSelectSub (name) {
      if(name !== 'prohome') {
        this.setCollapsed(false)
      }else{
        this.setCollapsed(true)
      }
      this.$emit('on-select', name)
    },
  },
  computed: {
    textColor () {
      return this.theme === 'dark' ? '#515a6e' : '#495060'
    },
    checkname () {
      return !this.$route.matched[0].name ? 'main_index' : this.$route.matched[0].name
    },
    checkSubname () {
      return !this.$route.name ? 'main_index' : this.$route.name
    },
    submenudata () {
      return this.$store.state.app.submenu
    }
  },
  mounted () {
    forEach(this.menuList, item => {
      if(item.name == this.$route.matched[0].name) {
        this.setSubMenu(item)
      }
    })
    if(this.$route.name !== 'main_index' && this.$route.name !== 'trendsinfo'){
      this.setCollapsed(false)
    }else{
      this.setCollapsed(true)
    }
  }
}
</script>
<style lang="less">
@import './side-menu.less';
</style>
